import { TCheckoutLayout } from "../../core/types/Checkout"
import { IProductPrice } from "../../core/types/Product"
import CheckoutButtonCommit2 from "./Layouts/Layout2/CheckoutButtonCommit2"
import CheckoutButtonCommit3 from "./Layouts/Layout3/CheckoutButtonCommit3"
import CheckoutButtonCommit4 from "./Layouts/Layout4/CheckoutButtonCommit4"
import CheckoutButtonCommit5 from "./Layouts/Layout5/CheckoutButtonCommit5"
import CheckoutButtonCommit6 from "./Layouts/Layout6/CheckoutButtonCommit6"
import CheckoutButtonCommit7 from "./Layouts/Layout7/CheckoutButtonCommit7"
import CheckoutButtonCommit8 from "./Layouts/Layout8/CheckoutButtonCommit8"
import CheckoutButtonCommitDefault from "./Layouts/LayoutDefault/CheckoutButtonCommitDefault"

interface ICheckoutButtonCommit {
  layout?: TCheckoutLayout
  data: IProductPrice | null
  paymentMethodType: number
  paymentInstallment: number
  paymentTotal: number
  paymentValue: number
}

const CheckoutButtonCommit = ({ layout, ...props }: ICheckoutButtonCommit) => {
  if (!layout) return <></>

  const checkoutButtonCommitData = {
    [TCheckoutLayout.Default]: <CheckoutButtonCommitDefault />,
    [TCheckoutLayout.Layout2]: <CheckoutButtonCommit2 />,
    [TCheckoutLayout.Layout3]: <CheckoutButtonCommit3 />,
    [TCheckoutLayout.Layout4]: <CheckoutButtonCommit4 />,
    [TCheckoutLayout.Layout5]: <CheckoutButtonCommit5 />,
    [TCheckoutLayout.Layout6]: <CheckoutButtonCommit6 />,
    [TCheckoutLayout.Layout7]: <CheckoutButtonCommit7 />,
    [TCheckoutLayout.Layout8]: <CheckoutButtonCommit8 {...props} />,
  }

  return checkoutButtonCommitData[layout] || <></>
}

export default CheckoutButtonCommit
